// Stimulus controller for dynamically displaying the correct value input
// for a selected ActivityQuestion in a nested form for activity entries.
//
// Usage:
// - Each activity entry contains:
//   - A <select> element to choose an ActivityQuestion
//   - Pre-rendered input wrappers for each possible question, each with:
//     - data-vm--activity-entry-form-target="inputWrapper"
//     - data-question-id="[activity_question_id]"
// - When the question is selected, only the matching input wrapper is shown.
//   All others are hidden and their inputs disabled to avoid form submission.
//
// Targets:
// - questionSelect: the <select> element for choosing the question
// - inputWrapper: containers that hold input fields for each question
//

import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["questionSelect", "inputWrapper"];
  
  questionSelectTarget: HTMLSelectElement;
  inputWrapperTargets: HTMLElement[];

  connect(): void {
    this.showRelevantInput();
  }

  showRelevantInput(): void {
    const selectedQuestionId = this.questionSelectTarget.value;

    this.inputWrapperTargets.forEach(wrapper => {
      const isMatch = wrapper.dataset.questionId === selectedQuestionId;

      wrapper.style.display = isMatch ? "block" : "none";

      // Disable all inputs in non-matching wrappers
      const inputs = wrapper.querySelectorAll<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>("input, select, textarea");
      inputs.forEach(input => {
        input.disabled = !isMatch;
      });
    });
  }
}
